import type { HttpClient } from '../http';
import { unwrap, type ApiEnvelope } from '../envelope';
import type { NotificationItem } from '../types/domain';

export function notificationEndpoints(http: HttpClient) {
  return {
    list: (opts: { unread?: boolean; page?: number } = {}) =>
      http.get<ApiEnvelope<NotificationItem[]>>('/v1/me/notifications', { query: { unread: opts.unread, page: opts.page } }).then(unwrap),
    unreadCount: async (): Promise<number> => {
      try {
        const d = await http.get<ApiEnvelope<{ unreadCount: number }>>('/v1/me/notifications/unread-count').then(unwrap);
        return d?.unreadCount ?? 0;
      } catch {
        return 0;
      }
    },
    markRead: (id: string) => http.post<ApiEnvelope<unknown>>(`/v1/me/notifications/${id}/read`, {}).then(unwrap),
    markAllRead: () => http.post<ApiEnvelope<unknown>>('/v1/me/notifications/read-all', {}).then(unwrap),
    streamPath: '/v1/me/notifications/stream',
  };
}
export type NotificationEndpoints = ReturnType<typeof notificationEndpoints>;
